/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x4ba5c2 from'./compiledmessages.js';export default class MessagesCompressor{static['decode'](_0x40d00a,_0x3f97d8){const _0x4c6901=_getType(_0x3f97d8)['decode']('undefined'==typeof window?_0x40d00a:new Uint8Array(_0x40d00a));return _0x3f97d8['fromJSON']({..._0x4c6901});}static['encode'](_0xe5bd7a){const _0x1bca49=_getType(_0xe5bd7a['constructor']),_0x5e3904=_0xe5bd7a['toJSON'](),_0x20a6e4=_0x1bca49['verify'](_0x5e3904);if(_0x20a6e4)throw Error(_0x20a6e4);return _0x1bca49['encode'](_0x1bca49['create'](_0x5e3904))['finish']();}}function _getType(_0x379dfe){return _0x4ba5c2[_0x379dfe['DESCRIPTOR_NAME']];}